import numberToPersian from "./NumberToPersian";

const ShowRefereePoints = (props) => {
  let roundA = "bg-white";
  let roundB = "bg-white";
  let roundC = "bg-white";
  let totalRound = "bg-white";

  let blue_point = 0;
  let red_point = 0;

  if (props.rounds.roundA === "blue") {
    roundA = "bg-primary";
    blue_point += 1;
  } else if (props.rounds.roundA === "red") {
    roundA = "bg-danger";
    red_point += 1;
  } else if (props.rounds.roundA === "white") {
    roundA = "bg-secondary";
  } else {
    roundA = "bg-white";
  }

  if (props.rounds.roundB === "blue") {
    roundB = "bg-primary";
    blue_point += 1;
  } else if (props.rounds.roundB === "red") {
    roundB = "bg-danger";
    red_point += 1;
  } else if (props.rounds.roundB === "white") {
    roundB = "bg-secondary";
  } else {
    roundB = "bg-white";
  }

  if (props.rounds.roundC === "blue") {
    roundC = "bg-primary";
    blue_point += 1;
  } else if (props.rounds.roundC === "red") {
    roundC = "bg-danger";
    red_point += 1;
  } else if (props.rounds.roundC === "white") {
    roundC = "bg-secondary";
  } else {
    roundC = "bg-white";
  }

  if (blue_point > red_point) {
    totalRound = "bg-primary";
  } else if (red_point > blue_point) {
    totalRound = "bg-danger";
  } else {
    totalRound = "bg-secondary";
  }

  return (
    <div
      className="col-md-2 col-sm-12 text-center"
      style={{ textAlign: "right", direction: "rtl" }}
    >
      <div className="referee-area">
        <h6>داور شماره {numberToPersian(props.refereeNo)}</h6>
        <div className="row mt-3">
          <div className="col-6">
            <div className="show-point bg-primary text-white">
              {props.bluePoint != 0 ? numberToPersian(props.bluePoint) : 0}
            </div>
          </div>
          <div className="col-6">
            <div className="show-point bg-danger text-white">
              {props.redPoint != 0 ? numberToPersian(props.redPoint) : 0}
            </div>
          </div>
          <div
            className="col-12 mt-3 IRANSansNormal"
            style={{
              textAlign: "right",
              fontSize: "13px",
              lineHeight: "2em",
            }}
          >
            <div className="row mt-4">
              <div className="col-8">راند اول: </div>
              <div
                className="col-4"
                style={{ textAlign: "left", direction: "ltr" }}
              >
                <div className={"winner-round " + roundA}>&nbsp;</div>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-8">راند دوم: </div>
              <div
                className="col-4"
                style={{ textAlign: "left", direction: "ltr" }}
              >
                <div className={"winner-round " + roundB}>&nbsp;</div>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-8">راند سوم: </div>
              <div
                className="col-4"
                style={{ textAlign: "left", direction: "ltr" }}
              >
                <div className={"winner-round " + roundC}>&nbsp;</div>
              </div>
            </div>
            <div className="row mt-2 final-point">
              <div className="col-8">برنده نهایی: </div>
              <div
                className="col-4"
                style={{ textAlign: "left", direction: "ltr" }}
              >
                <div className={"winner-round " + totalRound}>&nbsp;</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* تغییرات سرداور */}
      <div className="head-changes mt-1">
        <h6 style={{ fontSize: "14px" }}>تغییرات سرداور</h6>

        <div className="row IRANSansNormal mt-4">
          <div className="col-6" style={{ fontSize: "14px" }}>
            این راند:{" "}
          </div>
          <div
            className="col-6"
            style={{ textAlign: "left", direction: "ltr" }}
          >
            <span className="badge bg-danger">{props.head_redpoint}</span>{" "}
            &nbsp;
            <span className="badge bg-primary">{props.head_bluepoint}</span>
          </div>
        </div>
        <div className="row IRANSansNormal mt-3">
          <div className="col-6" style={{ fontSize: "14px" }}>
            کل مسابقه:{" "}
          </div>
          <div
            className="col-6"
            style={{ textAlign: "left", direction: "ltr" }}
          >
            <span className="badge bg-danger">{props.head_total_redpoint}</span>{" "}
            &nbsp;
            <span className="badge bg-primary">
              {props.head_total_bluepoint}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowRefereePoints;
